<template>
  <section class="domain" :class="{ loading: isLoading }">
    <slot v-if="isReady"></slot>
    <error-message :error="error" />
  </section>
</template>
<script>
import { ErrorMessage } from "@/components";

export default {
  name: "Domain",
  components: {
    "error-message": ErrorMessage,
  },
  props: {
    clusterName: {
      type: String,
    },
    domainName: {
      type: String,
    },
    error: {
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
    isReady: {
      type: Boolean,
    },
    origin: {
      type: String,
    },
  },
  watch: {
    clusterName() {
      this.$emit("onClusterChange");
    },
    domainName() {
      this.$emit("onDomainChange");
    },
    origin() {
      this.$emit("onOriginChange");
    },
  },
  created() {},
};
</script>
